<template>
  <div>
    <h3 class="font-weight-bold" v-if="$route.params.id <= 0">สร้างแคมเปญ</h3>
    <h3 class="font-weight-bold" v-else>รายละเอียดแคมเปญ</h3>
    <div class="header-purple">รายละเอียด</div>
    <div class="p-3 bg-white">
      <b-container class="p-0">
        <b-row class="no-gutters">
          <b-col>
            <InputSelect
              :id="'inventoryBookDetailChannel' + $route.params.id"
              title="ช่องทางการขาย"
              name="channel"
              :options="channelLists"
              valueField="id"
              textField="name"
              isRequired
              v-model="form.channel"
              class="mr-2"
              @onDataChange="onBranchChange($event)"
            />
          </b-col>
          <b-col>
            <InputSelect
              :id="'inventoryBookDetailStatus' + $route.params.id"
              title="สถานะ"
              name="status"
              :options="statusLists"
              valueField="id"
              textField="name"
              isRequired
              v-model="form.status"
              @onDataChange="onStatusChange($event)"
            />
          </b-col>
        </b-row>
        <b-row class="no-gutters">
          <b-col cols="6">
            <InputText
              :id="'inventoryBookDetailName' + $route.params.id"
              textFloat="ชื่อแคมเปญ"
              v-model="form.campaignName"
              class="mr-2"
              placeholder="ชื่อแคมเปญ"
              type="text"
              :isValidate="$v.form.campaignName.$error"
              isRequired
              :v="$v.form.campaignName"
              @onDataChange="(val) => (form.campaignName = val)"
            />
          </b-col>
        </b-row>
        <b-row class="no-gutters">
          <b-col>
            <div>
              <p class="mb-1 label-input">
                วันที่แคมเปญ (เริ่มต้น) <span class="text-danger">*</span>
              </p>
              <div
                :class="[
                  'input-container mr-2',
                  { error: $v.form.startCampaign.$error },
                ]"
              >
                <datetime
                  :input-style="styleDatetime"
                  v-model="form.startCampaign"
                  placeholder="วว / ดด / ปป"
                  ref="startCampaignDate"
                  :input-id="'inventoryBookDetailStartDate' + $route.params.id"
                >
                </datetime>
                <div
                  class="icon-container text-right"
                  @click="$refs.startCampaignDate.isOpen = true"
                >
                  <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
                </div>
              </div>
              <div v-if="$v.form.startCampaign.$error">
                <span class="text-error">กรุณาเลือกวันที่</span>
              </div>
            </div>
          </b-col>
          <b-col>
            <div>
              <p class="mb-1 label-input">
                วันที่แคมเปญ (สิ้นสุด) <span class="text-danger">*</span>
              </p>
              <div
                :class="[
                  'input-container mr-2',
                  { error: $v.form.endCampaign.$error },
                ]"
              >
                <datetime
                  :input-style="styleDatetime"
                  v-model="form.endCampaign"
                  placeholder="วว / ดด / ปป"
                  ref="endCampaignDate"
                  :min-datetime="form.startCampaign"
                  :input-id="'inventoryBookDetailEndDate' + $route.params.id"
                >
                </datetime>
                <div
                  class="icon-container text-right"
                  @click="$refs.endCampaignDate.isOpen = true"
                >
                  <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
                </div>
              </div>
              <div v-if="$v.form.endCampaign.$error">
                <span class="text-error">กรุณาเลือกวันที่</span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="no-gutters">
          <b-col>
            <div class="mt-3">
              <p class="mb-1 label-input">
                วันที่จองสินค้า (เริ่มต้น) <span class="text-danger">*</span>
              </p>
              <div
                :class="[
                  'input-container mr-2',
                  { error: $v.form.startBooking.$error },
                ]"
              >
                <datetime
                  :input-style="styleDatetime"
                  v-model="form.startBooking"
                  placeholder="วว / ดด / ปป"
                  ref="startBookingDate"
                  :input-id="
                    'inventoryBookDetailReserveStartDate' + $route.params.id
                  "
                >
                </datetime>
                <div
                  class="icon-container text-right"
                  @click="$refs.startBookingDate.isOpen = true"
                >
                  <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
                </div>
              </div>
              <div v-if="$v.form.startBooking.$error">
                <span class="text-error">กรุณาเลือกวันที่</span>
              </div>
            </div>
          </b-col>
          <b-col>
            <div class="mt-3">
              <p class="mb-1 label-input">
                วันที่จองสินค้า (สิ้นสุด) <span class="text-danger">*</span>
              </p>
              <div
                :class="[
                  'input-container mr-2',
                  { error: $v.form.endBooking.$error },
                ]"
              >
                <datetime
                  :input-style="styleDatetime"
                  v-model="form.endBooking"
                  placeholder="วว / ดด / ปป"
                  ref="endBookingDate"
                  :min-datetime="form.startBooking"
                  :input-id="
                    'inventoryBookDetailReserveEndDate' + $route.params.id
                  "
                >
                </datetime>
                <div
                  class="icon-container text-right"
                  @click="$refs.endBookingDate.isOpen = true"
                >
                  <font-awesome-icon icon="calendar-alt" color="#B41BB4" />
                </div>
              </div>
              <div v-if="$v.form.endBooking.$error">
                <span class="text-error">กรุณาเลือกวันที่</span>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="p-3 bg-white">
      <b-container class="px-0">
        <b-row>
          <b-col xl="4">
            <b-input-group class="panel-input-serach">
              <b-form-input
                :id="'inventorySearchBookDetail' + $route.params.id"
                class="input-serach"
                placeholder="ค้นหาชื่อสินค้า, SKU, คอลเลคชั่นสินค้า"
                v-model="filterInventoryList.search"
                v-on:keyup.13="handlePushMessage"
              ></b-form-input>
              <b-input-group-prepend>
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon icon="search" title="View" />
                </span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
          <b-col xl="8" class="text-right">
            <div class="d-flex justify-content-xl-end h-100">
              <b-dropdown
                :id="'dropdownInventoryBookDetail' + $route.params.id"
                text="ตัวเลือกเพิ่มเติม"
                class="ml-2 dropdown-option h-100"
              >
                <b-dropdown-item
                  @click="$router.push('/product/details/0')"
                  :id="'dropdownInventoryBookDetailCreateProduct' + $route.params.id"
                  >สร้างสินค้า Non-Sap</b-dropdown-item
                >
                <b-dropdown-item>นำออกข้อมูล</b-dropdown-item>
                <b-dropdown-item>ดาวน์โหลดไฟล์ต้นฉบับ</b-dropdown-item>
              </b-dropdown>

              <InventoryFilter
                name="DetailCampaign"
                v-on:onSubmitFilter="onSubmitFilter"
              />
              <b-button @click="showModal" :id="'btnInventoryBookDetailAddProduct'+$route.params.id" class="btn-main ml-2 h-100">
                <span>เพิ่มสินค้า </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
        <InventoryAddProductModal
          ref="addProductModal"
          @add-product="addProduct"
          :listId="listAllDataId"
          :name="'BookDetail'+ $route.params.id"
        />
      </b-container>
      <div class="mt-3">
        <div class="header-purple">กระจายสินค้ารายชิ้น</div>
        <b-table
          responsive
          striped
          class="text-center table-list mb-0"
          :items="items"
          :fields="fields"
          :busy="isBusy"
          show-empty
          empty-text="ไม่พบข้อมูล"
          ref="table"
        >
          <template v-slot:cell(imageUrl)="data">
            <div class="position-relative">
              <div
                class="square-box b-contain"
                v-bind:style="{
                  'background-image': 'url(' + data.item.imageUrl + ')',
                }"
              ></div>
            </div>
          </template>

          <template v-slot:cell(productName)="data">
            <div class="text-left">
              <p class="mb-0 text-weight-bold">{{ data.item.productName }}</p>
              <p class="mb-0 text-black-50" v-if="data.item.productSKU">
                {{ data.item.productSKU }}
              </p>
              <p class="mb-0 text-black-50" v-else>{{ data.item.sku }}</p>
            </div>
          </template>
          <template v-slot:cell(allStock)="data">
            <div>
              <!-- ทั้งหมด = จำนวนคงเหลือ - จำนวนที่จอง -->
              <p class="mb-0">{{ data.item.allStock }}</p>
            </div>
          </template>
          <template v-slot:cell(totalStock)="data">
            <div>
              <!-- คงเหลือ = จำนวนทั้งหมด - จำนวนที่จอง -->
              <p class="mb-0" v-if="!data.item.reserve">
                {{ data.item.allStock }}
              </p>
              <p
                class="mb-0"
                v-else-if="
                  parseInt(data.item.allStock) - parseInt(data.item.reserve) > 0
                "
              >
                {{
                  autoChangeTotalStock(
                    data.index,
                    parseInt(data.item.allStock),
                    parseInt(data.item.reserve)
                  )
                }}
              </p>
              <p class="mb-0" v-else>0</p>
            </div>
          </template>
          <template v-slot:cell(reserve)="data">
            <InputTextStock
                        :id="'inputInventoryBookDetail'+$route.params.id+'ProdId'+data.item.productId"
              :isValidate="$v.items.$each.$iter[data.index]['reserve'].$error"
              :v="$v.items.$each.$iter[data.index]['reserve']"
              textFloat=""
              v-model="data.item.reserve"
              isRequired
              class="mr-2"
              placeholder=""
              type="number"
            />
            <!-- <b-form-input type="number" v-model.number="data.item.reserve" /> -->
          </template>
          <template v-slot:cell(productId)="data">
            <font-awesome-icon
            :id="'btnDeleteInventoryBookDetail'+$route.params.id+'ProdId'+data.item.productId"
              class="pointer"
              icon="trash-alt"
              @click="deleteItem(data.item.productId)"
            />
          </template>
        </b-table>
      </div>
    </div>
    <div class="mt-3 d-flex justify-content-between">
      <div>
        <b-button class="btn-main-2" @click="cancel" :id="'cancelInventoryBookDetail'+$route.params.id">
          ยกเลิก
        </b-button>
        <b-button
          v-if="$route.params.id > 0"
          class="btn-main-2 ml-2"
          @click="deleteCampaign"
          :id="'deleteInventoryBookDetail'+$route.params.id"
        >
          ลบ
        </b-button>
      </div>
      <b-button class="btn-main" @click="onSave" :id="'saveInventoryBookDetail'+$route.params.id"> บันทึก </b-button>
    </div>

    <ModalAlertConfirm
      msg="ยืนยันการลบ"
      text="คุณแน่ใจหรือไม่ว่าต้องการลบ"
      btnConfirm="ลบ"
      btnCancel="ยกเลิก"
      ref="isModalAlertConfirm"
      @confirm="confirmDelete"
    />
    <ModalLoading ref="modalCampaignLoading" :hasClose="false" />
    <ModalAlert
      ref="modalCampaignSuccess"
      :text="textSuccess"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalCampaignAlert" :text="textAlert" />
  </div>
</template>

<script>
import { required, minValue, numeric } from "vuelidate/lib/validators";
import InventoryFilter from "../inventory-filter/InventoryFilter.vue";
import InputText from "@/components/inputs/InputText";
import InputTextStock from "../input/InputTextStock.vue";
import InputSelect from "@/components/inputs/InputSelect";
import InventoryDataList from "../inventory-custom/InventoryDataList.json";
import InventoryAddProductModal from "../inventory-custom/modal/InventoryAddProductModal.vue";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
export default {
  name: "InventoryCreateBoook",
  components: {
    InputText,
    InputTextStock,
    InputSelect,
    InventoryAddProductModal,
    InventoryFilter,
    ModalAlertConfirm,
    ModalLoading,
    ModalAlert,
    ModalAlertError,
  },
  data: function() {
    return {
      form: {
        channel: "",
        status: 1,
        campaignName: "",
        startCampaign: new Date().toISOString(),
        endCampaign: new Date(
          new Date().getTime() + 24 * 60 * 60 * 1000
        ).toISOString(),
        startBooking: new Date().toISOString(),
        endBooking: new Date(
          new Date().getTime() + 24 * 60 * 60 * 1000
        ).toISOString(),
      },
      textAlert: "",
      textSuccess: "",
      flag: 0,
      newCampaignId: 0,
      styleDatetime: {
        width: "100%",
        border: "none",
      },
      statusLists: [
        { name: "ยังไม่เริ่ม", id: 1 },
        { name: "ดำเนินอยู่", id: 2 },
        { name: "เสร็จแล้ว", id: 3 },
      ],
      channelLists: [],
      items: [],
      listAllDataId: [],
      isBusy: false,
      productDetailCampaign: [],
      filterInventoryList: {
        search: "",
        productInventoryTypes: [],
        productStatus: [],
        categories: [],
        stockStatus: [],
        StartDate: "",
        EndDate: "",
      },
      InventoryDataList,
      fields: [
        {
          key: "imageUrl",
          label: "ภาพสินค้า",
          class: "w-100px",
        },
        {
          key: "productName",
          label: "SKU - ชื่อสินค้า",
          class: "w-100px",
        },
        {
          key: "allStock",
          label: "จำนวนทั้งหมด",
          class: "w-100px",
        },
        {
          key: "totalStock",
          label: "จำนวนคงเหลือ",
          class: "w-100px",
        },
        {
          key: "reserve",
          label: "จำนวนที่ต้องการเข้าร่วม",
          class: "w-200",
        },
        {
          key: "productId",
          label: "",
          class: "w-50px",
        },
      ],
    };
  },
  async created() {
    await this.getFilter();
    this.getBranchList();
    this.getProductList();
    this.getDetail();
  },
  beforeDestroy() {
    localStorage.controlTabInventory = 5;
  },
  methods: {
    getFilter() {
      if (this.$route.query.search) {
        this.filterInventoryList.search = this.$route.query.search;
      }
      if (this.$route.query.productInventoryTypes) {
        this.filterInventoryList.productInventoryTypes = this.$route.query.productInventoryTypes;
      }
      if (this.$route.query.productStatus) {
        this.filterInventoryList.productStatus = this.$route.query.productStatus;
      }
      if (this.$route.query.categories) {
        this.filterInventoryList.categories = this.$route.query.categories;
      }
      if (this.$route.query.stockStatus) {
        this.filterInventoryList.stockStatus = this.$route.query.stockStatus;
      }
      if (this.$route.query.StartDate) {
        this.filterInventoryList.StartDate = this.$route.query.StartDate;
      }
      if (this.$route.query.EndDate) {
        this.filterInventoryList.EndDate = this.$route.query.EndDate;
      }
    },
    setFilter() {
      this.$router
        .push({
          path: "/inventory",
          query: {
            brandID: this.$route.query.brandID,
            search: this.filterInventoryList.search,
            productInventoryTypes: this.filterInventoryList
              .productInventoryTypes,
            productStatus: this.filterInventoryList.productStatus,
            categories: this.filterInventoryList.categories,
            stockStatus: this.filterInventoryList.stockStatus,
            StartDate: this.filterInventoryList.StartDate || "",
            EndDate: this.filterInventoryList.EndDate || "",
          },
        })
        .catch((err) => {});
    },
    getBranchList() {
      this.axios.get(`${this.$baseUrl}/brand/BranchList`).then((data) => {
        this.channelLists = data.detail;
        this.form.channel = this.channelLists[0].id;
      });
    },
    getDetail() {
      this.form = {
        channel: 116,
        status: 1,
        campaignName: "",
        startCampaign: new Date().toISOString(),
        endCampaign: new Date(
          new Date().getTime() + 24 * 60 * 60 * 1000
        ).toISOString(),
        startBooking: new Date().toISOString(),
        endBooking: new Date(
          new Date().getTime() + 24 * 60 * 60 * 1000
        ).toISOString(),
      };

      this.axios
        .get(
          `${this.$baseUrl}/stockdistribute/campaign/${this.$route.params.id}`
        )
        .then((data) => {
          if (data.detail.campaignDetail) {
            this.form.channel = data.detail.campaignDetail.branchId;

            this.form.status = data.detail.campaignDetail.statusId;

            this.form.campaignName = data.detail.campaignDetail.campaignName;
            this.form.startCampaign =
              data.detail.campaignDetail.campaignStartTime;
            this.form.endCampaign = data.detail.campaignDetail.campaignEndTime;
            this.form.startBooking =
              data.detail.campaignDetail.reserveStartTime;
            this.form.endBooking = data.detail.campaignDetail.reserveEndTime;
            this.isBusy = false;
            this.productDetailCampaign = data.detail.productDetail;
          }
        });
    },
    getProductList(filter) {
      if (filter) {
        this.filterInventoryList = filter;
        this.setFilter();
      }
      this.isBusy = true;
      // this.items = this.InventoryDataList.detail.dataList;
      this.addAmountProduct();
      this.axios
        .post(
          `${this.$baseUrl}/stockdistribute/campaignproduct/${this.$route.params.id}`,
          this.filterInventoryList
        )
        .then((data) => {
          this.listAllDataId = data.detail.listAllDataId;
          this.items = data.detail.data;

          // set ค่า จำนวนทั้งหมด = จำนวนคงเหลือ + จำนวนที่จอง
          for (let x in this.items) {
            this.items[x].allStock =
              this.items[x].totalStock + this.items[x].reserve;
          }
          this.isBusy = false;
        });
    },
    showModal() {
      this.$refs["addProductModal"].openModal();
    },
    addAmountProduct() {
      this.items.map((invent) => {
        invent.reserve = 0;
      });
    },
    // deleteItem(id) {
    //   this.$refs.isModalAlertConfirm.show();
    // },
    deleteItem(id) {
      let itemUpdate = [];
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].productId == id) {
          itemUpdate = this.items.filter((item) => item.productId != id);
        }
      }
      this.items = itemUpdate;
      let listIdUpdate = this.listAllDataId.filter((itemId) => itemId != id);
      this.listAllDataId = listIdUpdate;
      // this.getProductList();
      // this.$refs.isModalAlertConfirm.hide();
    },
    onStatusChange(value) {
      this.form.status = value;
    },
    onBranchChange(value) {
      this.form.channel = value;
    },
    onSave() {
      this.$v.form.$touch();
      this.$v.items.$touch();
      if (this.$v.items.$error || this.$v.form.$error) {
        return;
      }
      this.$refs.modalCampaignLoading.show();
      var campaign = {
        // "campaignId": 31,
        campaignName: this.form.campaignName,
        campaignStartTime: this.form.startCampaign,
        campaignEndTime: this.form.endCampaign,
        reserveStartTime: this.form.startBooking,
        reserveEndTime: this.form.endBooking,
        branchId: 148,
        // this.form.channel
        Status: this.form.status,
        Products: this.items,
        //  [
        //     {
        //         "ProductId": 398,
        //         "Reserve": 15
        //     },
        //     {
        //         "ProductId": 403,
        //         "Reserve": 11
        //     },
        //     {
        //         "ProductId": 404,
        //         "Reserve": 12
        //     }
        // ]
      };
      this.axios
        .post(`${this.$baseUrl}/stockdistribute/campaign`, campaign)
        .then((data) => {
          this.$refs.modalCampaignLoading.hide();

          if (data.result == 0) {
            this.textAlert = data.detail;
            this.$refs.modalCampaignAlert.show();
          } else {
            this.textSuccess = "สำเร็จ";
            this.$refs.modalCampaignSuccess.show();
            this.newCampaignId = data.detail.campaignDetail.campaignId;
            this.flag = 2;
            // this.getProductList();
            // this.getDetail();
          }
        });
    },
    onSubmitFilter(filter) {
      this.setFilter();
      this.getProductList(filter);
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.onSubmitFilter();
      }
    },
    hasHistory() {
      return window.history.length > 2;
    },
    handleRoute() {
      if (this.hasHistory()) this.$router.back();
      else
        this.$router.push({
          path: `/inventory?brandID=${this.$route.query.brandID}`,
        });
    },
    cancel() {
      this.handleRoute();
    },
    deleteCampaign() {
      this.$refs.isModalAlertConfirm.show();
    },
    confirmDelete() {
      this.$refs.isModalAlertConfirm.hide();

      this.axios
        .delete(
          `${this.$baseUrl}/stockdistribute/campaign/${this.$route.params.id}`
        )
        .then((data) => {
          this.$refs.modalCampaignLoading.hide();

          if (data.result == 0) {
            this.textAlert = data.detail;
            this.$refs.modalCampaignAlert.show();
          } else {
            this.textSuccess = "สำเร็จ";
            this.$refs.modalCampaignSuccess.show();
            this.flag = 1;
          }
        });
    },
    hadleModalAlertClose() {
      if (this.flag == 1) {
        this.cancel();
      } else if (this.flag == 2) {
        this.$router.push(
          `/inventory/create-campaign/${this.newCampaignId}?brandID=${this.$route.query.brandID}  `
        );
      }
    },
    addProduct(products, productsId) {
      this.items = this.items.filter((item) =>
        productsId.includes(item.productId)
      );

      for (let i = 0; i < products.length; i++) {
        if (!this.listAllDataId.includes(products[i].productId)) {
          let total = {
            totalStock: products[i].onlineStock, // คงเหลือ
            allStock: products[i].onlineStock, // ทั้งหมด total + reserve
            reserve: 1,
            SpecialDistributeId: 0,
          };
          this.items.push({ ...products[i], ...total });
        }
      }
      this.listAllDataId = productsId;
    },
    autoChangeTotalStock(index, allStock, reserve) {
      this.items[index].totalStock = allStock - reserve;
      return this.items[index].totalStock;
    },
  },
  validations() {
    const rules = {
      form: {
        channel: { required },
        status: { required },
        campaignName: { required },
        startCampaign: { required },
        endCampaign: { required },
        startBooking: { required },
        endBooking: { required },
      },
      items: {
        $each: {
          reserve: {
            required,
            minValue: minValue(0),
            numeric: numeric,
            isOverTotalStock(value, value2) {
              if (parseInt(value2.reserve) > value2.allStock) {
                return false;
              } else {
                return true;
              }
            },
          },
        },
      },
    };
    return rules;
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  display: flex;
  padding: 0.5rem;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
}

.icon-container {
  flex: 1 1 auto;
  cursor: text;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.input-container.error {
  border-color: red !important;
}
.label-input {
  font-weight: bold;
  font-size: 14px;
}
</style>
